import React, { lazy } from 'react';
// import { message } from 'antd';
import { useSelector } from 'react-redux'; // useDispatch, 
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from 'react-router-dom'; // useHistory
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
// import { clearUserData } from '../../redux/CrmReduxCalls/LocalDataReduxStore';

const Dashboard = lazy(() => import('../../container/dashboard'));
const AddCompany = lazy(() => import('../../container/dashboard/Pages/GrowSquare/AddCompany'));
const companyUpdate = lazy(() => import('../../container/dashboard/Pages/GrowSquare/AddCompanyUpdate'));
const Administration = lazy(() => import('../../container/dashboard/Administration/Administration'))
const GrowsquarePage = lazy(() => import('../../container/dashboard/Pages/GrowSquare/Administration'))
const Details = lazy(() => import('../../container/dashboard/Pages/DetailsPage/AllDetailPage'))
const SubcriptionUI = lazy(() => import('../../container/dashboard/Pages/GrowSquare/Subscription'))

function PrivateRoute({ component: Component, allowedRoles, basePath, ...rest }) {
  // const localData = useSelector((state) => state.localRedux);
  // const permission = localData.permissions;
  const permission = "ALL"
  const userRoles = permission ? permission.split(",").map(r => r.trim()) : [];
  const hasAccess = allowedRoles.some(role => userRoles.includes(role) || userRoles.includes("ALL"));
  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess ? (
          <Component {...props} />
        ) : (
          <Redirect to={basePath} />
        )
      }
    />
  );
}
PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  basePath: PropTypes.string.isRequired,
};

const routesConfig = [
  { path: "/details", component: Details, roles: ["ALL", "GrowSquare"] },
  { path: "/administration", component: Administration, roles: ["ALL"] },
  { path: "/subscription", component: SubcriptionUI, roles: ["ALL"] },
  { path: "/growSquare", component: GrowsquarePage, roles: ["ALL", "GrowSquare"] },
  { path: "/company", component: AddCompany, roles: ["ALL", "GrowSquare"] },
  { path: "/company-update", component: companyUpdate, roles: ["ALL", "GrowSquare"] },
];

function DashboardRoutes() {
  const { path } = useRouteMatch();
  const localData = useSelector((state) => state.localRedux);
  const roles = localData.role

  return (
    <Switch>
      {roles !== "Super Admin" ? (
        <Route exact path={path} component={Dashboard} />
      ) : (
        <Route exact path={path} component={Administration} />
      )}
      {routesConfig.map(({ path: subPath, component, roles }) => (
        <PrivateRoute
          key={subPath}
          path={`${path}${subPath}`}
          component={component}
          allowedRoles={roles}
          basePath={path}
        />
      ))}
      <Route render={() => <Redirect to={path} />} />
    </Switch>
  );
}

export default DashboardRoutes;

